/* global axios */

import PortalsAPI from './portals';

class CategoriesAPI extends PortalsAPI {
  constructor() {
    super('categories', { accountScoped: true });
  }

  get({ portalSlug, locale }) {
    return axios.get(`${this.url}/${encodeURIComponent(portalSlug)}/categories?${new URLSearchParams({ locale })}`);
  }

  show(portalSlug, categoryId) {
    return axios.get(`${this.url}/${encodeURIComponent(portalSlug)}/categories/${encodeURIComponent(categoryId)}`);
  }

  show(portalSlug, categoryId) {
    return axios.get(`${this.url}/${portalSlug}/categories/${categoryId}`);
  }
  
  create({ portalSlug, categoryObj }) {
    return axios.post(`${this.url}/${encodeURIComponent(portalSlug)}/categories`, categoryObj);
  }

  update({ portalSlug, categoryId, categoryObj }) {
    return axios.patch(
      `${this.url}/${encodeURIComponent(portalSlug)}/categories/${encodeURIComponent(categoryId)}`,
      categoryObj
    );
  }

  delete({ portalSlug, categoryId }) {
    return axios.delete(`${this.url}/${encodeURIComponent(portalSlug)}/categories/${encodeURIComponent(categoryId)}`);
  }

  updatePosition(portalSlug, categoryId, position) {
    return axios.patch(`${this.url}/${encodeURIComponent(portalSlug)}/categories/${encodeURIComponent(categoryId)}/update_position`, {
      category: { position }
    });
  }

  updatePosition(portalSlug, categoryId, position) {
    return axios.patch(`${this.url}/${portalSlug}/categories/${categoryId}/update_position`, {
      category: { position }
    });
  }  
}

export default new CategoriesAPI();
